import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqueId from 'react-html-id';
import SideBarItem from '../SideBarItem/SideBarItem';

class SideBarItemList extends Component {
  static propTypes = {
    items: PropTypes
      .arrayOf(PropTypes.shape({
        id: PropTypes
          .oneOfType([PropTypes.number, PropTypes.string])
          .isRequired,
        label: PropTypes.string.isRequired,
        img: PropTypes.string.isRequired,
      }))
      .isRequired,
    name: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
    className: PropTypes.string,
    activeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  static defaultProps = {
    activeId: 0,
    className: '',
  }

  constructor() {
    super();
    uniqueId.enableUniqueIds(this);
  }

  clickHandler = (id) => {
    const { name, changeHandler } = this.props;
    changeHandler({ name, id });
  }

  render() {
    const { items, activeId, className } = this.props;
    const currentActive = activeId || (items[0] && items[0].id);
    const sideBarListClasses = classNames({
      'side-bar-list': true,
      [className]: true,
    });
    return (
      <div className={sideBarListClasses}>
        {items.map(item => (
          <SideBarItem
            key={this.nextUniqueId()}
            id={item.id}
            label={item.label}
            img={item.img}
            clickHandler={() => {
              this.clickHandler(item.id);
             }}
            active={currentActive === item.id}
          />))}
      </div>
    );
  }
}

export default SideBarItemList;



// WEBPACK FOOTER //
// ./src/components/_molecules/SideBar/SideBarItemList/SideBarItemList.js